"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgMessageEditorCtl = /** @class */ (function (_super) {
    __extends(DlgMessageEditorCtl, _super);
    function DlgMessageEditorCtl() {
        return _super.call(this, true) || this;
    }
    DlgMessageEditorCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            messageTitle: "",
            dialogTitle: "",
            messageBody: "",
            visible: false,
        };
    };
    DlgMessageEditorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgMessageEditorCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgMessageEditorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgMessageEditorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgMessageEditorCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgMessageEditorCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgMessageEditorCtl.prototype.SetDialogTitle = function (title) {
        this.DATA.dialogTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgMessageEditorCtl.prototype, "dialogTitle", {
        get: function () {
            return this.DATA.dialogTitle;
        },
        enumerable: true,
        configurable: true
    });
    DlgMessageEditorCtl.prototype.SetMessageTitle = function (title) {
        this.DATA.messageTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgMessageEditorCtl.prototype, "messageTitle", {
        get: function () {
            return this.DATA.messageTitle;
        },
        enumerable: true,
        configurable: true
    });
    DlgMessageEditorCtl.prototype.SetMessageBody = function (body) {
        this.DATA.messageBody = body;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgMessageEditorCtl.prototype, "messageBody", {
        get: function () {
            return this.DATA.messageBody;
        },
        enumerable: true,
        configurable: true
    });
    return DlgMessageEditorCtl;
}(BaseController_1.BaseController));
exports.DlgMessageEditorCtl = DlgMessageEditorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgMessageEditorCtl.ts
// module id = 899
// module chunks = 0